import React, { useContext } from 'react';
import classNames from 'classnames';
import HelmetWrapper from 'components/HelmetWrapper';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import OnboardingContext from 'router/subrouters/DataRoom/providers/Onboarding/Onboarding.context';
import ShareableLinksContentContainer from 'router/subrouters/DataRoom/components/ShareableLinksContentContainer';

import './ShareableLinks.styles.scss';

type ShareableLinksProps = {
  className?: string;
};

const ShareableLinks: React.FC<ShareableLinksProps> = (props) => {
  const { className } = props;

  const classes = classNames('shareable-links', 'page', className);

  const {
    dataRoom: { name },
  } = useContext(DataRoomContext);
  const { contentCard } = useContext(OnboardingContext);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <HelmetWrapper title={`${t('secureShares')} - ${name}`} />
      <h2>{t('secureShares')}</h2>
      {contentCard}

      <ShareableLinksContentContainer showIsActiveToggle />
    </div>
  );
};

export default ShareableLinks;
